import { cloneDeep } from 'lodash'

import { FormGroupBase } from '../components/FormGroupBase'

/**
 * Form Builder factory.  Base FormBuilder
 * @param {object} rawFormControls - FormControls
 * @returns {object} ExtendedFormGroup - Mixin
 */
const FormBuilder = (rawFormControls) => {
  const formGroup = FormGroupBase(rawFormControls)

  return {
    computed: {
      ...formGroup.computed,
    },
    data() {
      // Deep clone the data to ensure each component instance has its own state
      return cloneDeep(formGroup.data)
    },
    methods: {
      ...formGroup.methods,
    },
    unmounted() {
      const controlKeys = Object.keys(rawFormControls)

      for (const controlName of controlKeys) {
        this[`${controlName}Reset`]()
      }
    },
    watch: {
      ...formGroup.watch,
    },
  }
}

export { FormBuilder }
